const constants = {
  booking: {
    navigateTo: {
      vehicles: '/choose',
      extras: '/extras',
      payment: '/payment',
      confirmation: '/confirmation',
    },
    pageNumber: {
      vehicles: 1,
      extras: 2,
      payment: 3,
      confirmation: 4,
    },
    milesNBonus: {
      eligible: 'Eligible',
      eligibleBrand: 'Hertz',
    },
  },
  extras: {
    manually: 'M',
    auto: 'A',
  },
  modify: {
    navigateTo: {
      pendingPayment: '/pending-payment',
      acceptPendingPayment: '/accept-pending-payment',
      modifyCancel: '/modify-cancel',
      acceptModification: '/accept-modification',
      confirmation: '/confirmation',
    },
    pageNumber: {
      modifyCancel: 1,
      pendingPayment: 1,
      acceptModification: 2,
      acceptPendingPayment: 2,
      confirmation: 3,
    },
  },
  transmissions: {
    automatic: 'Automatic',
    manual: 'Manual',
  },
}

export default constants
